import { Badge } from "react-bootstrap";

export const STATUS_BADGE = {
    PRESENT: "bg-success bg-opacity-25 border-success text-success",
    ABSENT: "bg-danger bg-opacity-25 border-danger text-danger",
    LATE: "bg-warning bg-opacity-25 border-warning text-dark",
    DEFAULT: "bg-primary bg-opacity-25 border-primary text-secondary",
};



export default function StudentSession({ trainingDates }) {
    const hasData = trainingDates && trainingDates.length > 0;

    return (
        <table className="table table-bordered">
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Session</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                {hasData ? (
                    trainingDates.map((dateItem) =>
                        dateItem.sessions.map((session, idx) => (
                            <tr key={`${dateItem.date}-${session.session}`}>
                                {idx === 0 && (
                                    <td rowSpan={dateItem.sessions.length}>
                                        {dateItem.date}
                                    </td>
                                )}
                                <td>{session.session.toUpperCase()}</td>
                                <td>
                                   <Badge
                                        className={`border rounded-3 px-3 py-2 ${
                                            STATUS_BADGE[session.status] || STATUS_BADGE.DEFAULT
                                        }`}
                                    >
                                        <span className="fw-bold">{session.status}</span>
                                    </Badge>

                                </td>
                            </tr>
                        ))
                    )
                ) : (
                    <tr>
                        <td colSpan={5} className="text-center">
                            No data available
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
}
